export default function AudioContent() {
  return {
    width: '100%'
  };
}
